import { Text } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Box, Center } from 'native-base';

export const AssetEndOfList = () => {
  return (
    <Box w={'100%'} py={Spacing['stack.xxxs']}>
      <Center>
        <Text textAlign={'center'} variant="regular" color="neutral.black" lineHeight="distant">
          Você chegou ao final da lista. Caso não tenha encontrado seu ativo,{'\n'}
          utilize o{' '}
          <Text
            textAlign={'center'}
            variant="semibold"
            color="brand.tertiary.principal"
            lineHeight="distant">
            CAMPO DE BUSCA
          </Text>{' '}
          acima para pesquisar.
        </Text>
      </Center>
    </Box>
  );
};
